import { crc64 } from 'crc64-ecma'
export const calculateCRC64 = (evmAddress: string): string => {
  const crcResult = crc64(evmAddress)
  return (parseInt(crcResult.toString(16), 16) % 1e16).toString()
}
